const _ = require('lodash');

const aafesData = document.getElementById('uc-loader').getAttribute('data-aafes-info');
const aafesObj = JSON.parse(aafesData);

const addToCartUrl = _.get(aafesObj, 'b2bPostURL');
const aafesAuth = _.get(aafesObj, 'aafes_auth');

const AafesLoader = {
  addToCartUrl,
  aafesAuth,
};

export default AafesLoader;



// WEBPACK FOOTER //
// ./src/base/scripts/loaders/aafes.js